import { Component, OnInit, HostListener } from '@angular/core';
import { AppService } from './main/services/app.service';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute, ActivationEnd } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	title = 'zverp-booking-engine';
	isLoading: boolean;
	showBanner: boolean;
	deferedPrompt: any;
	domainId: any;

	constructor(
		private router: Router, 
		private route: ActivatedRoute, 
		public appService: AppService){
		router.events.forEach((event) => {
			if(event instanceof NavigationStart) {
				this.isLoading = true;
			} else if (event instanceof NavigationEnd){
				this.isLoading = false;
			} else if (event instanceof ActivationEnd){
				this.createDynamicManifestPWA(event.snapshot.params['domainId']);
			}
			// NavigationCancel
			// NavigationError
			// RoutesRecognized
		});
	}

	createDynamicManifestPWA(domainId: any): void{
		this.appService.createManifestPWA(domainId)
		.subscribe((myDynamicManifest) => {
			if (myDynamicManifest){
				const stringManifest = JSON.stringify(myDynamicManifest);
				const blob = new Blob([stringManifest], {type: 'application/json'});
				const manifestURL = URL.createObjectURL(blob);
				document.querySelector('#my-manifest-domain').setAttribute('href', manifestURL);
			}
		});
	}

	closeBanner(): void{
		this.showBanner = false;
	}

	@HostListener('window:beforeinstallprompt', ['$event'])
	onbeforeinstallprompt(e: any): void {
		e.preventDefault();
		this.deferedPrompt = e;
		this.showBanner = true;
	}

	@HostListener('window:appinstalled', ['$event'])
	onAppInstalled(e: any): void{
		console.log('app installed');
	}

	ngOnInit(): void{}

	onInstallBtnClick(): void{
		if (this.deferedPrompt) {
			this.deferedPrompt.prompt();
			this.deferedPrompt.userChoice.then(result => {
				if (result.outcome === 'accepted') {
					console.log('user accepted add to homescreen');
				} else {
					console.log('user dismissed the add to homescreen');
				}
				this.deferedPrompt = null;
				this.showBanner = false;
			});
		}
	}
}
